export default "__VITE_ASSET__DCZHnvrF__"